import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';

@Component({
    selector: 'app-kamona-carousel',
    templateUrl: './kamona-carousel.component.html',
    styleUrls: ['./kamona-carousel.component.scss'],
})
export class KamonaCarouselComponent implements OnInit {
    currentView: CarouselType;
    @Input() carouselTemplateRef: TemplateRef<any>;
    @Input() carouselType = CarouselType;
    @Input() autoplay = 5000;
    @Input() slidesPerView = 1;
    @Input() spaceBetween = 24;
    @Input() carouselItems: any[] = [];
    @Input() enableTouchSwipe: boolean;
    @ViewChild('kamonaSwiper', { static: false }) swiper: any;

    constructor() {}

    ngOnInit(): void {
        this.currentView = CarouselType.BASIC;
    }
}

export enum CarouselType {
    BASIC = 'BASIC',
}
